import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { EstimationSchemesApi } from '@/common/api/estimationScheme';
import type { EstimationScheme } from '@/common/api/types/estimationScheme';
import { commonQueryKeys } from '@/common/queryKeys/common';

export const getEstimationSchemesQueryOptions = () => {
  return {
    queryKey: commonQueryKeys.estimationSchemes.all(),
    queryFn: () => EstimationSchemesApi.getEstimationSchemes(),
  };
};

export const useGetEstimationSchemesQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery<EstimationScheme[]>({
    ...getEstimationSchemesQueryOptions(),
    enabled,
  });
};

export const useSuspenseGetEstimationSchemesQuery = () => {
  return useSuspenseQuery<EstimationScheme[]>({
    ...getEstimationSchemesQueryOptions(),
  });
};

export const useGetEstimationSchemeQuery = ({
  schemeId,
  staleTime,
}: {
  schemeId: number;
  staleTime?: number;
}) => {
  return useQuery<EstimationScheme>({
    queryKey: commonQueryKeys.estimationSchemes.details(schemeId),
    queryFn: () => EstimationSchemesApi.getSchemeDetails({ schemeId }),
    enabled: schemeId != null && schemeId !== 0,
    staleTime,
  });
};

export const useEstimationsQuery = ({
  enabled = true,
  staleTime,
}: {
  enabled?: boolean;
  staleTime?: number;
} = {}) => {
  return useQuery({
    queryKey: commonQueryKeys.estimationSchemes.estimations,
    queryFn: () => EstimationSchemesApi.getEstimationSchemes(),
    select: (data) => data.flatMap((d) => d.estimations),
    enabled,
    staleTime,
  });
};
